import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
interface HeaderProps {
  activeSection?: string;
  onNavigate?: (sectionId: string) => void;
}
export function Header({
  activeSection = 'home',
  onNavigate
}: HeaderProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const handleNavigation = (sectionId: string) => {
    if (onNavigate) {
      onNavigate(sectionId);
    } else {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
    setIsMenuOpen(false);
  };
  // Close mobile menu on resize to desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) setIsMenuOpen(false);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);
  const isHomePage = typeof window !== 'undefined' && window.location.pathname === '/';
  // ALWAYS navy text on white background — no transparent state
  const NAVY = '#0A1628';
  const HOVER = '#3B5998';
  return <header style={{
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 50,
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(20px)',
    WebkitBackdropFilter: 'blur(20px)',
    borderBottom: '1px solid rgba(0, 0, 0, 0.06)',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.04)',
    padding: '12px 0',
    transition: 'all 0.3s ease'
  }} data-id="element-268">
      <div className="container mx-auto max-w-[var(--maxw)] px-4 sm:px-6 flex justify-between items-center" data-id="element-269">
        {/* Logo */}
        <a href="/" className="flex items-center flex-shrink-0" style={{
        zIndex: 51
      }} data-id="element-270">
          <img src="https://cdn.magicpatterns.com/uploads/9Pc1EdXJ5Kiaov2hDznTrF/CIA_Logo_latest.png" alt="COSMO IMAGE AVIATION" style={{
          height: '40px',
          transition: 'all 0.3s'
        }} className="md:h-12" data-id="element-271" />
        </a>

        {/* Mobile menu button */}
        <button style={{
        color: NAVY,
        zIndex: 51,
        padding: '8px'
      }} className="lg:hidden rounded-md" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label="Toggle menu" data-id="element-272">
          {isMenuOpen ? <XIcon className="w-6 h-6" data-id="element-273" /> : <MenuIcon className="w-6 h-6" data-id="element-274" />}
        </button>

        {/* Navigation */}
        <nav aria-label="Main navigation" className={`${isMenuOpen ? 'flex flex-col fixed inset-0 top-0 pt-24 px-6 overflow-y-auto' : 'hidden'} lg:flex lg:items-center lg:space-x-8 lg:static lg:p-0 lg:w-auto`} style={isMenuOpen ? {
        zIndex: 40,
        backgroundColor: 'rgba(255, 255, 255, 0.98)',
        backdropFilter: 'blur(24px)',
        WebkitBackdropFilter: 'blur(24px)'
      } : {}} data-id="element-275">
          <ul className="flex flex-col lg:flex-row lg:items-center space-y-4 lg:space-y-0 lg:space-x-1" data-id="element-276">
            {['home', 'about', 'services', 'fleet', 'contact'].map(item => {
            const isActive = activeSection === item;
            return <li key={item} data-id="element-277">
                  <a href={`/#${item}`} style={{
                display: 'block',
                padding: '8px 16px',
                fontSize: '14px',
                fontWeight: isActive ? 700 : 600,
                color: NAVY,
                textDecoration: isActive ? 'underline' : 'none',
                textUnderlineOffset: '4px',
                transition: 'opacity 0.2s'
              }} onMouseEnter={e => {
                e.currentTarget.style.opacity = '0.6';
              }} onMouseLeave={e => {
                e.currentTarget.style.opacity = '1';
              }} onClick={e => {
                if (isHomePage) {
                  e.preventDefault();
                  handleNavigation(item);
                } else {
                  setIsMenuOpen(false);
                }
              }} data-id="element-278">
                    {item.charAt(0).toUpperCase() + item.slice(1)}
                  </a>
                </li>;
          })}
          </ul>

          {/* CTA Button */}
          <div className="mt-8 lg:mt-0 lg:ml-6" data-id="element-279">
            <button onClick={() => {
            if (isHomePage) {
              handleNavigation('contact');
            } else {
              window.location.href = '/#contact';
            }
          }} style={{
            padding: '10px 24px',
            borderRadius: '9999px',
            fontWeight: 600,
            fontSize: '14px',
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            transition: 'all 0.3s',
            backgroundColor: NAVY,
            color: '#ffffff',
            border: 'none',
            cursor: 'pointer',
            width: isMenuOpen ? '100%' : 'auto'
          }} onMouseEnter={e => {
            e.currentTarget.style.backgroundColor = HOVER;
          }} onMouseLeave={e => {
            e.currentTarget.style.backgroundColor = NAVY;
          }} data-id="element-280">
              Talk to Us
            </button>
          </div>
        </nav>
      </div>
    </header>;
}